import { useEffect } from "react";
import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    // const [auth, setAuth] = useState({});
    // const [token, setToken] = useState(null);


    // Read from storage immediately during initialization
    const storedAuth = sessionStorage.getItem("auth");
    const storedToken = sessionStorage.getItem("token");
    const storedAccessToken = sessionStorage.getItem("access_token");

    const [auth, setAuth] = useState(storedAuth ? JSON.parse(storedAuth) : {});
    const [token, setToken] = useState(storedToken || null);
    const [accessToken, setAccessToken] = useState(storedAccessToken || null);

    // Load from sessionStorage on page load
    // useEffect(() => {
    //     const storedAuth = sessionStorage.getItem("auth");
    //     const storedToken = sessionStorage.getItem("token");

    //     if (storedAuth) setAuth(JSON.parse(storedAuth));
    //     if (storedToken) setToken(storedToken);
    // }, []);

    // Save to sessionStorage when auth changes
    useEffect(() => {
        sessionStorage.setItem("auth", JSON.stringify(auth));
    }, [auth]);

    useEffect(() => {
        if (token) {
            sessionStorage.setItem("token", token);
        } else {
            sessionStorage.removeItem("token");
        }
    }, [token]);

    useEffect(() => {
        if (accessToken) {
            sessionStorage.setItem("access_token", accessToken);
        } else {
            sessionStorage.removeItem("access_token");
        }
    }, [accessToken]);


    return (
        <AuthContext.Provider value={{ auth, setAuth, token, setToken, accessToken, setAccessToken }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;